export default __webpack_public_path__ + "static/media/scientific-mono.fadd8f50.svg";